import React from "react";
import { ATLAS_APP_URL } from "../lib/atlas";

/** World setup: send the user to Argon Atlas to post there. */
export function AtlasSetupPrompt({ onAtlas = false }) {
  if (onAtlas) {
    return (
      <div
        className="atlas-setup-prompt atlas-setup-prompt--disabled"
        aria-disabled="true"
      >
        <div className="atlas-setup-prompt__title">On Argon Atlas</div>
      </div>
    );
  }

  return (
    <a className="atlas-setup-prompt" href={ATLAS_APP_URL}>
      <div className="atlas-setup-prompt__title">Post this to Argon Atlas?</div>
    </a>
  );
}
